import { render, staticRenderFns } from "./TestimonialEditor.vue?vue&type=template&id=2232de74&scoped=true"
import script from "./TestimonialEditor.vue?vue&type=script&lang=js"
export * from "./TestimonialEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2232de74",
  null
  
)

export default component.exports